$(document).ready(function() {
  
  $('.slick_mobile_only').slick({
    lazyLoad: 'ondemand', 
    centerMode: true,
    centerPadding: '30px',
    arrows: false,
    mobileFirst: true,
    slidesToShow: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: 'unslick'
      }
    ]
  });
  
  $('.slick_mobile_only_3').slick({
    lazyLoad: 'ondemand', 
    centerMode: true,
    centerPadding: '30px',
    arrows: false,
    mobileFirst: true,
    slidesToShow: 2,
    responsive: [
      {
        breakpoint: 1024,
        settings: 'unslick'
      }
    ]
  });
  
  $('.slick_single').slick({
    lazyLoad: 'ondemand',
    dots: false,
    infinite: true,
    speed: 500,
    fade: true,
    cssEase: 'linear'
  });
  
  $('.slick_single_auto').slick({
    lazyLoad: 'ondemand', 
    dots: false,
    arrows: false,
    infinite: true,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 5000, 
    fade: true,
    cssEase: 'linear'
  });
  
  $('.slick_single_auto_dots').slick({
    lazyLoad: 'ondemand', 
    dots: true,
    infinite: true,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 5000, 
    fade: true,
    cssEase: 'linear'
  });
  
  
  $('.slick_variable-width').slick({
    lazyLoad: 'ondemand', 
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    centerMode: true,
    variableWidth: true
  });
  
  $('.slick_promos_3').slick({
    lazyLoad: 'ondemand', 
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [{
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          prevArrow: false,
          nextArrow: false
        }
      }, {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          prevArrow: false,
          nextArrow: false
        }
      }
    ]
  });

  $('.slick_promos_5').slick({ 
    lazyLoad: 'ondemand', 
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [{
        breakpoint: 1360,
        settings: {
          slidesToShow: 3
        }
      }, {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          centerMode: true
        }
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
          centerMode: true
        }
      }
    ]
  });

  $('.slick_products_3').slick({
    lazyLoad: 'ondemand', 
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [{
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          prevArrow: false,
          nextArrow: false
        }
      }, {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          prevArrow: false,
          nextArrow: false
        }
      }
    ]
  });

  $('.slick_products_4').slick({
    lazyLoad: 'ondemand', 
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [{
        breakpoint: 1360,
        settings: {
          slidesToShow: 4,
          prevArrow: false,
          nextArrow: false
        }
      },{
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          prevArrow: false,
          nextArrow: false
        }
      }, {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          prevArrow: false,
          nextArrow: false
        }
      }, {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
          prevArrow: false,
          nextArrow: false
        }
      }
    ]
  });

  $('.slick_products_5').slick({
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [{
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          prevArrow: false,
          nextArrow: false
        }
      }, {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          prevArrow: false,
          nextArrow: false
        }
      }
    ]
  });

  $('.slick_store_reviews_auto').slick({
    lazyLoad: 'ondemand', 
    dots: false,
    arrows: false,
    infinite: true,
    slidesToShow: 2,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 5000, 
    fade: false,
    cssEase: 'linear',
    responsive: [{
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }, {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
  
  $('.slick_community_space').slick({
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    centerMode: true,
    variableWidth: true
  });

  
  
  // You can unslick at a given breakpoint now by adding:
  // settings: "unslick"
  // instead of a settings object

});